export default {
  title: 'Receba novidades e ofertas por email',
  form: {
    marketing_subscription: {
      label: 'Receba ofertas exclusivas, descontos e novidades diretamente na sua caixa de entrada',
    },
  },
};
